import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PreloaderService {
  readonly loading = signal(false);
  private pending = 0;

  show() {
    this.pending++;
    if (this.pending === 1) this.loading.set(true);
  }

  hide() {
    this.pending = Math.max(0, this.pending - 1);
    if (this.pending === 0) this.loading.set(false);
  }
}
